import logo from './img/logo-bleu.png';
import imageYes from './img/essence-yes.png';
import imageNo from './img/essence-no.png';
import { metadata } from '../engine/eligibility';

function formatEuro(value) {
  if (value == null || Number.isNaN(value)) return null;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  }).format(value);
}

export default function ResultScreen({ result, onRestart }) {
  const eligible = result?.status === 'eligible';
  const image = eligible ? imageYes : imageNo;

  return (
    <div className={`result-screen ${eligible ? 'result-screen--ok' : 'result-screen--ko'}`}>
      <div className="result-screen__inner">
        <div className="result-screen__visual desktop-only">
          <img src={image} alt="" className="result-screen__hero" />
          <img src={logo} alt="Logo" className="result-screen__logo" />
        </div>
        <div className="result-screen__content">
          {eligible ? (
            <>
              <h2>
                <span className="accent">Félicitations !</span>
              </h2>
              <img className="mobile-only result-screen__hero" src={image} alt="" />
              <p>{result.message}</p>
              <p className="resultat-montant">
                <strong>
                  {result.amount}&nbsp;{result.currency === 'EUR' ? '€' : result.currency}
                </strong>
              </p>
              {result.rfrPerPart != null && (
                <><p className="result-detail">
                  Votre RFR par part : {formatEuro(result.rfrPerPart)} (plafond :{' '}
                  {formatEuro(result.threshold ?? metadata.rfr_threshold_per_part)}).
                </p>
                  <a
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();

                      window.parent.postMessage(
                        {
                          type: 'scroll-to',
                          id: 'Comment_faire_la_demande_daide_carburant_en_2026',
                        },
                        '*'
                      );
                    }}
                  >
                    Comment faire la demande ?
                  </a>
                </>
              )}
            </>
          ) : (
            <>
              <h2>Résultat de la simulation</h2>
              <img className="mobile-only result-screen__hero" src={image} alt="" />
              <p>{result.message}</p>
              {result.reason && (
                <div className="rejection-motif" role="status">
                  <strong>Motif du rejet</strong>
                  <p>{result.reason}</p>
                </div>
              )}
              {result.rfrPerPart != null && (
                <p className="result-detail">
                  Votre RFR par part : {formatEuro(result.rfrPerPart)} (plafond :{' '}
                  {formatEuro(result.threshold ?? metadata.rfr_threshold_per_part)}).
                </p>
              )}
            </>
          )}

          <p className="disclaimer">
            Les résultats sont donnés à titre indicatif. Seul le dépôt de votre demande permettra
            de connaître de façon certaine vos droits.
          </p>

          <button type="button" className="restart-btn-end" onClick={onRestart}>
            Recommencer
          </button>
          <img src={logo} alt="Logo" className="mobile-only result-screen__logo-mobile" />
        </div>
      </div>
    </div>
  );
}
